import axios from "./axios";

type PaginatedResponse<T> = {
  results: T[];
  next: string | null;
};

function isPaginatedResponse<T>(data: unknown): data is PaginatedResponse<T> {
  return (
    typeof data === "object" &&
    data !== null &&
    "results" in data &&
    Array.isArray((data as PaginatedResponse<T>).results)
  );
}

export async function fetchAllPaginated<T>(path: string): Promise<T[]> {
  let url: string | null = path;
  const items: T[] = [];

  while (url) {
    const resp: { data: unknown } = await axios.get(url);
    const data: unknown = resp.data;

    if (Array.isArray(data)) {
      return data;
    }

    if (!isPaginatedResponse<T>(data)) {
      return [];
    }

    items.push(...data.results);
    url = data.next;
  }

  return items;
}
